// @todo: can probably deprecate this
export const REDIS_KEYS = {
  IMG_CAT_ITINERARY_HEADER: 'img-cat:itinerary-header',
  IMG_CAT_WILDLIFE: 'img-cat:wildlife',
};
